import { TSurfaces, ESurfacesTypes } from './types';

export const surfacesTypes: TSurfaces = [
  {
    name: ESurfacesTypes.wall,
    label: 'Стены',
    materialLabel: 'Материал стен',
  },
  {
    name: ESurfacesTypes.floor,
    label: 'Пол',
    materialLabel: 'Материал пола',
  },
  {
    name: ESurfacesTypes.ceiling,
    label: 'Потолок',
    materialLabel: 'Материал потолка',
  },
  {
    name: ESurfacesTypes.wall_single,
    label: 'Стена',
    materialLabel: 'Материал стены',
  },
  {
    name: ESurfacesTypes.wall_linear,
    label: 'Стена (по ширине)',
    materialLabel: 'Материал стены (по ширине)',
  },
  {
    name: ESurfacesTypes.land_plot,
    label: 'Земельный участок',
    materialLabel: 'Материал земельного участка',
  },
];
